import { Box, Button, Text } from "@chakra-ui/react";
import Uppy from "@uppy/core";
import { useUppy } from "@uppy/react";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import DropTargetHandler from "../_plugins/uppy/drop-target-handler";
import { showToast } from "../_utils/showToast";
import FileInputCustom from "./FileInputCustom";
import { FaCloudUploadAlt } from "react-icons/fa";
import {
  getPhotoMaxSize,
  getVideoMaxSize,
} from "../_utils/assetsUtils/utils";
import { ASSETS_ALLOWED_FILE_EXTENSIONS, ASSET_MAX_FILE_UPLOAD_SIZE } from "../_utils/constants";

const wrapperStyles = {
  ".uppy-Dashboard-inner": {
    backgroundColor: "initial",
    border: "none",
  },
  ".uppy-ProviderBrowser-headerBar:empty": {
    display: "none",
  },
};
const dragzoneStyles = {
  border: "1px dashed hsla(0,0%,100%,.12)",
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "center",
  padding: 4,
  borderRadius: "4px",
  svg: {
    color: "whiteAlpha.500",
    height: "1.5rem",
    width: "1.5rem",
  },
};
const dropzoneBlack = {
  backgroundColor: "gray.600",
  height: "119px",
  width: "100%",
  padding: 4,
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "center",
  borderRadius: "4px",
  svg: {
    color: "whiteAlpha.500",
    height: "1.5rem",
    width: "1.5rem",
  },
  button: {
    width: "100%",
  },
};

const AssetsDropzone = ({ isUploading, borderedDesign, ...props }) => {
  const { t } = useTranslation(["folders"]);

  const uppy = useUppy(
    () =>
      new Uppy({
        id: "asset-dropzone",
        autoProceed: true,
        restrictions: {
          maxFileSize: ASSET_MAX_FILE_UPLOAD_SIZE,
          allowedFileTypes: ASSETS_ALLOWED_FILE_EXTENSIONS,
        },
        locale: {
          strings: {
            dropPasteFiles: `${t("assets.drag_and_drop")} %{browseFiles}`,
            browseFiles: t("assets.upload_asset"),
          },
        },
        onBeforeFileAdded: (files) => {
          const baseMimeType = files.type.split("/")[0];
          if (
            files.size > getPhotoMaxSize() ||
            files.size > getVideoMaxSize()
          ) {
            showToast({
              description: t("assets.file_size_error"),
              title: t("error", { ns: "common" }),
              status: "error",
            });
            return false;
          } else if (!["image","video","font","audio"].includes(baseMimeType)) {
            showToast({
              description: t("assets.file_type_error"),
              title: t("error", { ns: "common" }),
              status: "error",
            });
            return false;
          }
          return true;
        },
      })
  );

  useEffect(() => {
    uppy.use(DropTargetHandler, {
      target: ".assetDropbox",
    });

    const onFileAdded = (file) => {
      props.parentCallback([file.data]);

      uppy.removeFile(file.id);
    };

    uppy.on("file-added", onFileAdded);

    return () => {
      uppy.on("file-added", onFileAdded);
    };
  }, [uppy]);

  return (
    <Box sx={wrapperStyles}>
      <FileInputCustom uppy={uppy}>
        <Box sx={!borderedDesign ? dropzoneBlack : dragzoneStyles}>
          <FaCloudUploadAlt />
          <Text fontSize="0.75rem" color="whiteAlpha.500" my={1} textAlign="center">
            {t("assets.drag_and_drop")}
          </Text>
          <Button
            size="sm"
            variant="secondary"
            isLoading={isUploading}
            loadingText={t("assets.uploading")}
            whiteSpace="initial"
            lineHeight="1"
            size="md"
            width={["80%", "80%", "40%"]}
          >
            {t("assets.upload_asset")}
          </Button>
        </Box>
      </FileInputCustom>
    </Box>
  );
};

export default AssetsDropzone;
